import { type HTMLAttributes } from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface RatingProps extends HTMLAttributes<HTMLSpanElement> {
  value: number;
  reviews?: number;
  size?: number; // px, default 14
}

export function Rating({ value, reviews, size = 14, className, ...rest }: RatingProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 font-semibold text-[var(--ollio-ink)]', className)}
      aria-label={`Rated ${value} out of 5`}
      {...rest}
    >
      <Star
        className="fill-[var(--ollio-gold)] text-[var(--ollio-gold)]"
        style={{ width: size + 1, height: size + 1 }}
      />
      <span style={{ fontSize: size }}>{value}</span>
      {reviews != null && (
        <span className="text-muted font-medium">({reviews})</span>
      )}
    </span>
  );
}
